import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PANELS = [
  {
    eyebrow: "For Writers & Concept Owners",
    title: "Your idea deserves a path forward.",
    body: "Bring us a thought, premise, character, situation or concept. We can help identify the next development step and connect you with suitable writing talent or production partners.",
    tags: ["Idea Development", "Writer Collaboration", "Concept Ownership"],
    cta: "Share your idea",
    href: "mailto:suyog@veritasadvisory.co.in?subject=Story%20Idea%20—%20Goshta",
    testid: "collaborate-share-idea",
  },
  {
    eyebrow: "For Producers & Brands",
    title: "Find the right story and the right team.",
    body: "Access writing support from concept to screenplay and dialogue, with scope, deliverables, credits, rights and commercial terms discussed and documented for each project.",
    tags: ["Writer Matching", "Development Briefs", "Commercial Clarity"],
    cta: "Discuss a brief",
    href: "mailto:suyog@veritasadvisory.co.in?subject=Development%20Brief%20—%20Goshta",
    testid: "collaborate-discuss-brief",
  },
];

export default function GoshtaCollaborate() {
  return (
    <section
      id="collaborate"
      data-testid="goshta-collaborate"
      className="relative scroll-mt-24 bg-[#050505] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
            A Better Way to Collaborate
          </p>
          <h2 className="mt-5 max-w-3xl font-display text-3xl font-medium leading-tight text-neutral-100 sm:text-4xl lg:text-5xl">
            Better connections for writers, producers and{" "}
            <em className="italic text-[#D4AF37]">concept owners.</em>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-400">
            Goshta can help bring the right creative partners together and coordinate the
            commercial framework for each engagement, so expectations are clear from the beginning.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 lg:grid-cols-2">
          {PANELS.map((p, i) => (
            <Reveal key={p.testid} delay={i * 0.1} className="flex flex-col bg-[#0a0a0a] p-8 md:p-12">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">{p.eyebrow}</p>
              <h3 className="mt-5 font-display text-2xl text-neutral-100 sm:text-3xl">{p.title}</h3>
              <p className="mt-5 flex-1 text-base leading-relaxed text-neutral-400">{p.body}</p>
              <ul className="mt-8 flex flex-wrap gap-2.5">
                {p.tags.map((t) => (
                  <li
                    key={t}
                    className="border border-white/15 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-300"
                  >
                    {t}
                  </li>
                ))}
              </ul>
              <a
                data-testid={p.testid}
                href={p.href}
                className="mt-10 inline-flex w-fit items-center gap-2 border border-[#B79045]/60 px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#B79045] hover:text-black"
              >
                {p.cta} <ArrowUpRight size={14} />
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p data-testid="swa-disclaimer" className="mt-10 max-w-3xl text-xs leading-relaxed text-neutral-600">
            SWA-related writer connections are subject to writer availability and the
            association&rsquo;s applicable processes. Goshta coordinates commercial terms for
            engagements it handles; no association endorsement or exclusive authority is implied.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
